var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineAdvantages3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2565,
    height: 64,
    viewBox: "0 0 2565 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3052_1050)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2525.5 31.9609C2525.5 36.3792 2529.08 39.9609 2533.5 39.9609C2537.92 39.9609 2541.5 36.3792 2541.5 31.9609C2541.5 27.5427 2537.92 23.9609 2533.5 23.9609C2529.08 23.9609 2525.5 27.5427 2525.5 31.9609Z",
    fill: "#D71C25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2503.5 31.9609C2503.5 48.5295 2516.93 61.9609 2533.5 61.9609C2550.07 61.9609 2563.5 48.5295 2563.5 31.9609C2563.5 15.3924 2550.07 1.96094 2533.5 1.96094C2516.93 1.96094 2503.5 15.3924 2503.5 31.9609Z",
    stroke: "#71253C",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2503.5 32.959L0.0576172 31.9609",
    stroke: "url(#paint0_linear_3052_1050)",
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3052_1050",
    x1: 31.8109,
    y1: 32.4736,
    x2: 2479.43,
    y2: 33.4494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#031233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71253C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3052_1050"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2565,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineAdvantages3);
export default __webpack_public_path__ + "static/media/line-Advantages3.b4190f314a5050d439be79336f80206f.svg";
export { ForwardRef as ReactComponent };